import axios from "axios";
import { AddressInfoResponse } from "@genericTypes/sharedTypes";

export const getAddressInfo = async (
    search: string,
): Promise<AddressInfoResponse> => {
    const addressInfo = await axios.get(
        `/api/getGoogleAddress?address=${search}`,
    );
    return addressInfo.data as AddressInfoResponse;
};
